/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { observer, inject } from 'mobx-react';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from 'views/PageSections/ContentSection/ContentSection.module.scss';
import DevMenu from 'views/PageSections/Navigation/DevMenu/DevMenu';
import AuthenticationStore from 'stores/AuthenticationStore';
import { ENV } from 'config';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

// @translate() // Translate here is causing 2 renderings of the page. this should not be put in.
@inject('authenticationStore')
@observer
export default class ContentSectionP extends React.Component<*> {
  render(): React.Element<*> {
    const authenticationStore: AuthenticationStore = this.props.authenticationStore;
    const isLoggedIn: string = authenticationStore.isUserLoggedIn() ? '' : styles['logged-out'];

    return (
      <section id="content-section" className={`${styles['content-section']} ${isLoggedIn}`}>
        {this.props.children}
        {ENV === 'development' ? <DevMenu /> : null}
      </section>
    );
  }
}
